import type { ClientToServerEvents, ServerToClientEvents } from '@sw/protocol';
import type { Socket } from 'socket.io-client';
import i18n from '../i18n';
import { useChat } from '../stores/chat';
import { useGame } from '../stores/game';
import { useRoom } from '../stores/room';
import { useSession } from '../stores/session';
import { useUi } from '../stores/ui';
import { gameEvents } from '../game/events';

/** Único lugar donde los eventos del servidor llegan a los stores. */
export function bindHandlers(s: Socket<ServerToClientEvents, ClientToServerEvents>): void {
  s.on('session:state', ({ user, roomCode, serverTime }) => {
    useSession.getState().setServerState(roomCode, serverTime, user);
    if (!roomCode) {
      useRoom.getState().setRoom(null);
      useGame.getState().clear();
    }
  });
  s.on('server:shutdown', () => useSession.getState().setStatus('reconnecting'));
  s.on('lobby:rooms', (rooms) => useRoom.getState().setPublicRooms(rooms));
  s.on('room:state', (room) => {
    useRoom.getState().setRoom(room);
    if (!room) useGame.getState().clear();
  });
  s.on('game:view', (msg) => {
    const prev = useGame.getState();
    useGame.getState().setView(msg);
    gameEvents.onView(prev.gameId === msg.gameId ? prev.view : null, msg.view);
  });
  s.on('game:over', () => undefined);
  s.on('chat:history', (m) => useChat.getState().setHistory(m));
  s.on('chat:message', (m) => {
    useChat.getState().push(m);
    gameEvents.onChat(m);
  });
  s.on('notice', (n) => {
    const text = i18n.t(`notices.${n.code}`, { ...(n.params ?? {}) });
    useUi.getState().toast(n.code.startsWith('YOU_') ? 'warn' : 'info', text, 6000);
  });
}
